import { Injectable } from '@angular/core';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { MonographSalesCatalogue } from '../../models/monograph/monograph-sales-catalogue.model';

@Injectable({
    providedIn: 'root'
})
export class MonographSCPlanningLineRule {

    constructor(private monoGraphSC: MonographSalesCatalogue) { }

    validateMonoGraphSC(salesCatalogCode: string): CommercialItemValidationResponse {
        const isValid = this.monoGraphSC.code === salesCatalogCode;

        return {
            isValid,
        };
    }
}
